/* eslint-disable no-unsafe-optional-chaining */

/* eslint-disable react/no-array-index-key */

/* eslint-disable consistent-return */

/* eslint-disable camelcase */

/* eslint-disable import/no-unresolved */
import React from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import MenuComponent from '../../components/Menu';
import RestrictedContentComponent from '../../components/RestrictedContent';

import { useMoengageEventTracker } from '../../hooks/useMoengage';
import useSourceScreen from '../../hooks/useSourceScreen';
import { javaApi } from '../../utils/AxiosInstance';

import DownArrow from '../../assets/images/course-dashboard/DownArrow.gif';

import NotFoundContainer from '../NotFound';
import styles from './FreeCourses.module.scss';
import FreeCoursesCard from './FreeCoursesCard';

function FreeCoursesContainer() {
  const [freeCoursesCard, setFreeCoursesCard] = React.useState([]);
  const ref = React.useRef();
  const divRef = React.useRef(null);
  const screen = useSourceScreen();
  const trackMoengageEvent = useMoengageEventTracker();
  const [totalPages, setTotalPages] = React.useState(1);
  const [isDownArrow, setisDownArrow] = React.useState(false);
  const [isDivScroll, setIsDivScroll] = React.useState(false);

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const [page, setPage] = React.useState(1);
  const [loading, setLoading] = React.useState(true);

  const getFreeCoursesData = async () => {
    const response = await javaApi.get(`app-content-ws/v1/course/freeCoursesList?pageNumber=${page}&pageSize=${20}`);
    const data = await response?.data;
    const freeCoursesData = data?.data;
    if (freeCoursesData?.length > 0) {
      const totalNoPages = data?.totalPages;
      setTotalPages(Math.round(totalNoPages));
      if (page === 1) {
        setFreeCoursesCard(freeCoursesData);
      } else {
        setFreeCoursesCard((prev) => [...prev, ...freeCoursesData]);
      }
    }
    setLoading(false);
  };

  React.useEffect(() => {
    if (isAuthenticated) {
      if (page <= totalPages) {
        getFreeCoursesData();
      } else {
        setLoading(false);
      }
    } else {
      setPage(1);
      setFreeCoursesCard([]);
    }
  }, [page, isAuthenticated]);

  const handleInfiniteScroll = async () => {
    try {
      const divElement = document.getElementById('freeCoursesWrapper');
      if (divElement.scrollTop + divElement.clientHeight + 1 >= divElement.scrollHeight) {
        setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      // empty
    }
  };

  React.useEffect(() => {
    const divElement = document.getElementById('freeCoursesWrapper');
    if (typeof window !== 'undefined') {
      if (divElement) {
        divElement.addEventListener('scroll', handleInfiniteScroll);
        return () => {
          divElement.removeEventListener('scroll', handleInfiniteScroll);
          setFreeCoursesCard([]);
        };
      }
    }
  }, [isAuthenticated]);

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const downArrowDiv = divRef?.current;
      const handleScroll = () => {
        setIsDivScroll(true);
      };
      if (downArrowDiv) {
        setisDownArrow(downArrowDiv?.scrollHeight > downArrowDiv?.clientHeight);
        downArrowDiv?.addEventListener('scroll', handleScroll);
      }
      return () => {
        downArrowDiv?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [divRef?.current]);

  React.useEffect(() => {
    if (sessionStorage.getItem('MoeFlag')) {
      const screen_array = sessionStorage.getItem('sourceScreen_Array').split(',');
      try {
        trackMoengageEvent('free_courses_tapped', {
          screen_source: screen_array[screen_array?.length - 1] || screen,
          position: 'top',
        });

        sessionStorage.removeItem('MoeFlag');
      } catch (error) {
        // Handle error
      }
    }
  }, []);

  if (!isAuthenticated) return <RestrictedContentComponent />;

  return (
    <div className={styles.wrapper}>
      <aside ref={ref} className={classNames(styles.sidebar)}>
        <MenuComponent />
      </aside>
      <div className={styles.moduleWrapper}>
        <div className={styles.headerContainer}>
          <div className={styles.titleWrapper}>
            <span className={styles.purchaseTitle} />
          </div>
        </div>
        {!loading && freeCoursesCard?.length === 0 && (
          <NotFoundContainer title="Stay tuned, We are curating free courses for you!" />
        )}
        <div className={styles.cards} id="freeCoursesWrapper" ref={divRef}>
          {isDownArrow && !isDivScroll && freeCoursesCard?.length >= 7 && (
            <div className={styles.arrowWrapper}>
              <div className={styles.innerArrowContainer}>
                <Image unoptimized src={DownArrow} alt="DownArrow" />
              </div>
            </div>
          )}
          {freeCoursesCard?.length > 0 && <FreeCoursesCard data={freeCoursesCard} skeleton={false} />}
          {loading && <FreeCoursesCard data={freeCoursesCard} skeleton />}
        </div>
      </div>
    </div>
  );
}

export default FreeCoursesContainer;
